module.exports = __webpack_public_path__ + "static/26-thumb-311b0ee5d578b8f8e2796e68f1de6c83.jpg";